

/**
 * Agregar company id
 *
 */
export function setCompanyId(state,company_id) {
    state.company_id = company_id
}


/**
 * Agregar company id
 *
 */
export function setProducts(state,data) {
    state.products = data
}


/**
 * Setear información para dcr_historical_imports_pr
 *
 */
export function setDcrHistoricalImpPr(state,data) {
    state.dcr_historical_imports_pr = data
}



/**
 * Mutación para asignar los procesos en segundo plano.
 */
export function setBackgroundProcess(state, backgroundProcess) {
    state.backgroundProcess = backgroundProcess
}


/**
 * Mutación para setear los componentes
 */
export function setComponents(state, components) {
    state.components = components
}



/**
 * Calcular kg dependiendo de la unidad de medida seleccionada.
 *
 * @author Paul Valencia
 */
export function calculateKg(state, {mesure_unit_id, quantity, density = null}) {

    let kg_weight = 0;

    if (quantity && mesure_unit_id == 188) {
        density = null;
        kg_weight = quantity // kilogramos
    }

    if (quantity && mesure_unit_id == 189) {
        kg_weight = quantity * 0.453592; // Convertir libras a kilogramos
    }


    if (quantity && mesure_unit_id == 190) {
        kg_weight = quantity * density; // Convertir Litros  a kilogramos
    }

    if (quantity && mesure_unit_id == 191) {
        kg_weight = quantity * 1000 * density; // Convertir Metros cúbicos  a kilogramos
    }

    if (quantity && mesure_unit_id == 192) {
        kg_weight = quantity * 0.001;  // Convertir Gramos a kilogramos
    }

    if (quantity && mesure_unit_id == 193) {
        kg_weight = quantity * density / 1000; // Convertir Mililitros  a kilogramos
    }

    if (quantity && mesure_unit_id == 902) {
        let liters = quantity * 3.78;   // Convertir Galones  a kilogramos
        kg_weight = liters * density;
    }

    state.quantity_purchased_kg = (Math.round(kg_weight * 100) / 100).toFixed(2);

}
